import { Component } from '@angular/core';

@Component({
  selector: 'app-property-division-stage-pj',
  templateUrl: './property-division-stage-pj.component.html',
  styleUrls: ['./property-division-stage-pj.component.scss'],
})
export class PropertyDivisionStagePjComponent {
  constructor() {}
}
